import i18n from '@/locales/'
import { EXPENSE_TYPES, TRANSACTION_TYPE_CODES, TRANSACTION_STATUS } from '../_constants/constants'
import { REVIEW_STATUS } from '@/constants/reviewStatus'
export default {
  computed: {
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    officeHasMerchantFeature () {
      return this.$store.getters['CompanyStore/currentCompanyHasMerchantFeature']
    },
    budgets () {
      return this.$store.getters['UsersStore/userBudgets'] || []
    },
    transactionUserId () {
      return this.transaction &&
        this.transaction.card &&
        this.transaction.card.user
        ? this.transaction.card.user.id
        : 0
    },
    // USED IN FLEXIBLE RETRIBUTION!!

    transactionStatus () {
      return this.transaction && this.transaction.status
        ? this.transaction.status.code
        : ''
    },
    // USED IN FLEXIBLE RETRIBUTION!!
    transactionStatusClass () {
      if (!this.transactionStatus) return

      if (this.transactionReviewed) {
        return 'status--active'
      }
      if (this.transactionIsAuthorization) {
        return 'status--red'
      }
      if (this.transactionStatus === TRANSACTION_STATUS.OK) {
        return 'status--green'
      }
      if (this.transactionStatus === TRANSACTION_STATUS.KO) {
        return 'status--red'
      }
      return 'status--yellow'
    },
    // USED IN FLEXIBLE RETRIBUTION!!
    transactionStatusLabel () {
      if (!this.transactionStatus) return
      if (this.transactionIsAuthorization) {
        return this.$i18n.t('transactions_status__AUTHORIZATION')
      }

      return this.$i18n.t(`transactions_status__${this.transactionStatus}`)
    },
    transactionIsPending () {
      return this.transactionStatus === TRANSACTION_STATUS.PENDING
    },
    transactionIsDeclined () {
      return this.transactionStatus === TRANSACTION_STATUS.KO
    },
    transactionIsAuthorization () {
      return (
        Number.parseInt(this.transactionAmmount) === 0 && this.transactionType !== TRANSACTION_TYPE_CODES.EXPENSE
      )
    },
    transactionIsRefund () {
      return this.transactionAmmount > 0
    },
    transactionDate () {
      return this.transactionType === TRANSACTION_TYPE_CODES.NORMAL ? this.transaction.date : this.transaction.createdAt
    },
    transactionUserNameAndLastName () {
      if (this.$route?.meta?.users) {
        return this.transaction
          ? `${this.transaction.user_first_name} ${this.transaction.user_last_name}`
          : ''
      }
      return this.transaction &&
        this.transaction.card &&
        this.transaction.card.user
        ? `${this.transaction.card.user.firstName} ${this.transaction.card.user.lastName}`
        : ''
      // return this.transaction && this.transaction.user && this.transaction.user.name ? `${this.transaction.user.name} ${this.transaction.user.lastName}` : ''
    },

    transactionMerchant () {
      if (String(this.transactionType) === TRANSACTION_TYPE_CODES.NORMAL) {
        return this.normalTransactionMerchantLabel
      } else {
        return this.expenseTransactionLabel
      }
    },
    normalTransactionMerchantLabel () {
      if (this.officeHasMerchantFeature) {
        return this.transaction.merchantEntity &&
          this.transaction.merchantEntity.name
          ? this.transaction.merchantEntity.name
          : this.transaction.merchant
      }
      return this.transaction && this.transaction.merchant
        ? this.transaction.merchant
        : ''
    },
    expenseTransactionLabel () {
      if (
        this.transactionExpense &&
        this.transactionExpense.type.code === EXPENSE_TYPES.MILEAGE
      ) {
        return this.$i18n.t('MILEAGE')
      }
      if (this.transactionExpense && this.transactionExpense.type.code === EXPENSE_TYPES.DIET) {
        return this.$i18n.t('DIET')
      }
      return this.transaction.merchant
    },
    transactionActivityGroupLabel () {
      switch (this.transactionActivityGroup.code) {
        case 'RESTAURANTS':
          return this.$i18n.t('activity_group__RESTAURANTS')

        case 'TRANSPORT':
          return this.$i18n.t('activity_group__TRANSPORT')

        default:
          return this.$i18n.t('activity_group__OTHERS')
      }
    },
    transactionMerchantLogo () {
      if (this.officeHasMerchantFeature) {
        if (
          this.transaction.merchantEntity &&
          this.transaction.merchantEntity.logo
        ) {
          return this.transaction.merchantEntity.logo.id
        }
      }
      if (
        this.transaction.activityGroup &&
        this.transaction.activityGroup.logo
      ) {
        return this.transaction.activityGroup.logo.id
      }
      return null
    },
    transactionBudgetId () {
      return this.transaction && this.transaction.budget
        ? this.transaction.budget.id
        : ''
    },

    transactionHeaderStatusClass () {
      return this.transactionCategorizeStatus
        ? 'status--complete'
        : 'status--incomplete'
    },
    transactionBudgetName () {
      return this.transaction && this.transaction.budget
        ? this.transaction.budget.name
        : ''
    },
    transactionType () {
      return this.transaction.type && this.transaction.type.code
        ? this.transaction.type.code
        : ''
    },
    transactionPaymentMethod () {
      if (this.transactionType === TRANSACTION_TYPE_CODES.EXPENSE) {
        return this.transaction.paymentMethod?.officePaymentMethod?.name || ''
      } else {
        return `${this.$t(
          `transactions_card_type__${this.transactionCardType.code}`
        )} -${this.transactionCardPartialPAN}`
      }
    },
    transactionExpense () {
      return this.transaction && this.transaction.expense
        ? this.transaction.expense
        : false
    },
    isExpense () {
      return this.transactionExpense?.type?.code === EXPENSE_TYPES.EXPENSE
    },
    isMileage () {
      return this.transactionExpense
        ? this.transactionExpense.type.code === EXPENSE_TYPES.MILEAGE
        : false
    },
    isDiet () {
      return this.transactionExpense
        ? this.transactionExpense.type.code === EXPENSE_TYPES.DIET
        : false
    },
    transactionCardType () {
      return this.transaction &&
        this.transaction.card &&
        this.transaction.card.type
        ? this.transaction.card.type
        : ''
    },
    transactionCardPartialPAN () {
      return this.transaction &&
        this.transaction.card &&
        this.transaction.card.partialPAN
        ? `··· ${this.transaction.card.partialPAN}`
        : ''
    },
    transactionAmmount () {
      if (this.$route?.meta?.users) {
        return this.transaction ? this.transaction.total_amount_transactions : ''
      }
      return this.transaction ? this.transaction.amount : ''
    },
    transactionReceipt () {
      return this.transaction && this.transaction.receipt
        ? this.transaction.receipt
        : false
    },
    transactionReceiptType () {
      return this.transaction.receipt?.type
    },
    transactionReceiptIcon () {
      if (this.transactionReceiptType === 'RECEIPT') {
        return require('@/assets/img/icons/icon-receipt.svg')
      } else {
        return require('@/assets/img/icons/icon-invoice.svg')
      }
    },
    transactionUserProfilePictureId () {
      if (this.$route?.meta?.users) {
        return this.transaction ? this.transaction.profile_picture_media_id : ''
      }
      return this.transaction &&
        this.transaction.card &&
        this.transaction.card.user &&
        this.transaction.card.user.profilePicture
        ? this.transaction.card.user.profilePicture.id
        : 0
    },
    transactionHasAccountingPeriodClosed () {
      if (
        this.transaction &&
        this.transaction.receipt &&
        this.transaction.receipt.accountingPeriod
      ) {
        const accountingPeriod = this.transaction.receipt.accountingPeriod
        let name = accountingPeriod.name
        if (!name) {
          const startDate = this.$moment.utc(accountingPeriod.startDate).format(
            'DD/MM/YY'
          )
          const endDate = this.$moment.utc(accountingPeriod.endDate).format(
            'DD/MM/YY'
          )
          return `${startDate} - ${endDate}`
        }
        return name
      }
      return null
    },
    transactionHasLockedAt () {
      return !!(this.transaction && this.transaction.lockedAt)
    },
    transactionLockedBy () {
      return this.transactionHasLockedAt ? this.transaction.lockedBy : false
    },
    transactionIsLocked () {
      return (
        this.transactionHasLockedAt === true ||
        this.transactionHasAccountingPeriodClosed !== null
      )
    },
    transactionAccounted () {
      return this.transaction?.accountedAt
    },
    transactionAccountedBy () {
      return this.transactionAccounted ? this.transaction?.accountedBy : ''
    },

    transactionWithoutReceipt () {
      return this.transaction?.withoutTicket && (!this.receipts || this.receipts.length === 0)
    },
    transactionIsLockedIcon () {
      if (this.transactionIsLocked) {
        return this.transactionHasAccountingPeriodClosed !== null
          ? 'icon-agencia-tributaria'
          : 'icon-lock'
      }
      return null
    },
    transactionHasAdvise () {
      return this.transaction?.warnings?.length > 0 && this.transaction?.warnings.some(warning => !warning.ignored && warning.type.code !== 'AMOUNT_EXCHANGE_WRONG')
    },
    showWarnings () {
      return this.$route.name !== 'my_charged_transactions' && this.$route.name !== 'my_authorizations_transactions' && this.$route.name !== 'my_declined_transactions' && this.$route.name !== 'my_pending_reimbursements' && this.$route.name !== 'my_history_reimbursements'
    },
    transactionAdviseTooltipLabel () {
      let label = ''
      let labels = this.transaction?.warnings?.filter(item => !item.ignored && item.type.code !== 'AMOUNT_EXCHANGE_WRONG').map(item => item.type)
      labels.forEach(item => {
        let transactionKey = `transaction_warning_${item.code}`
        label += `<div>${this.$t(transactionKey)} \n</div>`
      })
      return label
    },
    transactionReviewed () {
      return this.transaction && this.transaction.reviewedAt
    },
    transactionReviewedBy () {
      return this.transactionReviewed ? this.transaction.reviewedBy : false
    },
    transactionIsProcessing () {
      return this.transaction?.processing
    },
    transactionStatusTooltip () {
      if (this.transactionIsProcessing) {
        return this.transactionProcessingTooltipLabel
      } else {
        return this.transactionStatusTooltiReviewStatusLabelTooltip()
      }
    },
    transactionProcessingTooltipLabel () {
      if (this.transactionIsProcessing) {
        return this.$i18n.t('transactions_processing_tooltip_label')
      }
      return ''
    },

    transactionReviewedByTooltipLabel () {
      if ((this.isAdmin || this.isBookKeeper) && this.transaction.accountedAt) {
        return this.$i18n.t('transaction_accounted_tooltip_label', [
          this.transactionReviewedBy.firstName,
          this.transactionReviewedBy.lastName,
          this.$moment.utc(this.transactionReviewed).format('DD/MM/YY HH:mm')
        ])
      } else if (this.transactionReviewed && this.transactionReviewedBy) {
        return i18n.t('transaction_review_tooltip_label', [
          this.transactionReviewedBy.firstName,
          this.transactionReviewedBy.lastName,
          this.$moment.utc(this.transactionReviewed).format('DD/MM/YY HH:mm')
        ])
      }
    },
    transactionLockedByTooltipLabel () {
      if (this.transactionHasAccountingPeriodClosed) {
        return i18n.t('transaction_lock_accounting_period', [
          this.transactionHasAccountingPeriodClosed
        ])
      }
      if (this.transactionHasLockedAt && this.transactionLockedBy) {
        return i18n.t('transaction_lock_tooltip_label', [
          this.transactionLockedBy.firstName,
          this.transactionLockedBy.lastName,
          this.$moment.utc(this.transaction.lockedAt).format('DD/MM/YY HH:mm')
        ])
      }
    },
    transactionIsMarkedAsPersonalExpense () {
      return (
        this.transaction &&
        this.transactionType === TRANSACTION_TYPE_CODES.NORMAL &&
        this.transaction.reviewStatus.code === REVIEW_STATUS.APPROVED &&
        this.transaction.isPersonalExpense
      )
    },
    transactionActivityGroup () {
      return this.transaction && this.transaction.activityGroup
        ? this.transaction.activityGroup
        : false
    },
    transactionMerchantClass () {
      // TODO: Uncomment when merchant names and logos are fixed
      // if (this.transaction.merchantEntity && this.transaction.merchantEntity.logo && this.transaction.merchantEntity.logo.id) {
      //   return 'badge-border bg-white'
      // }
      if (this.transactionActivityGroup.code === 'RESTAURANTS') {
        return 'badge-border background--blue'
      }
      if (this.transactionActivityGroup.code === 'TRANSPORT') {
        return 'badge-border background--red'
      }
      return 'badge-border bg-secondary'
    }
  },
  methods: {
    transactionStatusTooltiReviewStatusLabelTooltip () {
      let label = ''
      if (this.transactionAccounted && this.transactionAccountedBy) {
        label += this.$i18n.t('transaction_accounted_tooltip_label', [
          this.transactionAccountedBy?.firstName,
          this.transactionAccountedBy.lastName,
          this.$moment.utc(this.transactionAccounted).format('DD/MM/YY HH:mm')
        ])
      }

      if (this.transactionReviewed && this.transactionReviewedBy) {
        let reviewedByLabel = this.$i18n.t('transaction_review_tooltip_label', [
          this.transactionReviewedBy.firstName,
          this.transactionReviewedBy.lastName,
          this.$moment.utc(this.transactionReviewed).format('DD/MM/YY HH:mm')
        ])

        if (label) {
          label = label + '<br/>' + reviewedByLabel
        } else {
          label += reviewedByLabel
        }
      }

      return label
    }
  }

}
